import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Films from "./pages/categories/Films";
import Books from "./pages/categories/Books"; 
import Places from "./pages/categories/Places"; 
import Music from "./pages/categories/Music";
import Portfolio from "./pages/Portfolio";
import Profile from "./pages/Profile";
import "./App.css"; 

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/films" element={<Films />} />
        <Route path="/books" element={<Books />} />
        <Route path="/places" element={<Places />} /> 
        <Route path="/music" element={<Music />} /> 
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/profile" element={<Profile />} />
        
        {/* Tambahkan route /diary di sini jika nanti sudah siap */}
      </Routes>
    </Router>
  );
}

export default App;